<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeCreate from '../../../../employees/components/EmployeeCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <EmployeeCreate />
</template>